/* eslint-disable @typescript-eslint/no-explicit-any */
import { color } from 'asserts/styles/colors';
import { usePercentagesFromArray } from './usePercentagesFromArray';

const useHorizontalBarData = (type?: string) => {
  const getHorizontalBarData = (chart: any) => {
    const { ctx } = chart;

    const barTickness = chart.getDatasetMeta(0).data[0].height;

    chart.data.datasets.forEach((dataset: any, datasetIndex: number) => {
      const meta = chart.getDatasetMeta(datasetIndex);
      meta.data.forEach((datapoint: any, index: number) => {
        const peopleData: number = dataset.data[index]?.toLocaleString() || 0;
        ctx.beginPath();
        ctx.font = '13px Noto Sans KR';
        ctx.fillStyle = type === 'posture' ? `${color.white08}` : `${color.black04}`;
        ctx.textAlign = 'center';

        const getPercentagesFromArray = usePercentagesFromArray();

        const dataPercentages = getPercentagesFromArray(dataset.data)[index] ?? 0;

        const isValidPercentage = !isNaN(dataPercentages) && isFinite(dataPercentages);
        const rateCount = isValidPercentage ? ` ${dataPercentages.toFixed(1)}` : ' N/A';

        const textWidth = ctx.measureText(peopleData).width;
        if (type === 'posture') {
          ctx.fillText(`${peopleData}명`, datapoint.x + 25, datapoint.y + barTickness / 2);

          ctx.beginPath();
          ctx.font = '500 13px Noto Sans KR';
          ctx.fillStyle = `${color.white}`;
          ctx.fillText(`${rateCount}%`, datapoint.x + 45 + textWidth, datapoint.y + barTickness / 2);
        } else {
          ctx.fillText(`${peopleData}명`, datapoint.x - 25, datapoint.y + barTickness / 2);
        }
      });
    });
  };

  return getHorizontalBarData;
};

export default useHorizontalBarData;
